module.exports = __webpack_public_path__ + "static/img/packaged-turbofuel_64.b1a022d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packaged-turbofuel_64.png
// module id = Uow3
// module chunks = 0